import React from 'react';
import { ImageProps } from '.';

const SvgZexpressSimpleKor = ({ size = 70, ...props }: ImageProps): JSX.Element => {
  return (
    <svg width={size} height={(size && Math.floor(size / 2.1875)) || 32} fill='none' viewBox='0 0 70 32' {...props}>
      <g clipPath='url(#ZexpressSimpleKor_svg__a)'>
        <path
          fill='#6E52FF'
          d='M0 16C0 7.163 7.213 0 16.111 0H53.89C62.787 0 70 7.163 70 16s-7.213 16-16.111 16H16.11C7.213 32 0 24.837 0 16Z'
        />
        <path
          fill='#fff'
          d='M44.504 23.537h-2.083V19.98h-8.106v-1.65h10.189v5.206ZM50.746 21.63h8.22v1.648h-10.32V18.51h2.1v3.12ZM19.994 9.361c4.298-.067 7.784 2.627 7.784 6.622l-.011.368c-.209 3.79-3.61 6.316-7.773 6.25-.796-.013-1.409-.11-2.273-.348-2.709-.75-8.041-3.951-9.853-5.284-.185-.135-.064-.407.168-.385l10.911 1.039c.167.016.264.183.183.32l-1.05 1.788c-.117.197.126.407.33.287l6.347-3.763a.313.313 0 0 0 0-.547l-6.347-3.763c-.204-.12-.447.09-.33.288l1.05 1.787c.078.137-.016.304-.183.32L8.036 15.38c-.232.021-.35-.251-.168-.385 1.812-1.333 7.144-4.537 9.853-5.287.864-.238 1.477-.335 2.273-.347ZM58.575 19.48h-2.083V8.844h2.083V19.48ZM54.93 11.527h-2.98v.21c0 1.762 1.091 3.556 3.533 4.283l-1.058 1.617c-1.66-.517-2.832-1.576-3.5-2.91-.675 1.447-1.88 2.61-3.613 3.185l-1.074-1.617c2.457-.792 3.597-2.7 3.597-4.558v-.21H46.79V9.878h8.138v1.649ZM44.504 17.685h-2.083V8.828h2.083v8.857ZM40.858 11.333H37.88c.016 1.721 1.106 3.532 3.531 4.251l-1.057 1.6c-1.66-.509-2.832-1.568-3.5-2.91-.675 1.455-1.88 2.611-3.613 3.185l-1.074-1.6c2.44-.784 3.58-2.692 3.597-4.526H32.72V9.684h8.138v1.649Z'
        />
      </g>
      <defs>
        <clipPath id='ZexpressSimpleKor_svg__a'>
          <path fill='#fff' d='M0 0h70v32H0z' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgZexpressSimpleKor;
